if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {

		constructor() {
			super();

			if ( this.querySelector('product-form') ) {
				this.#init();
			}
		}

		#init() {

			this.querySelector('product-form').addEventListener('add-to-cart', () => {

				if ( ! document.body.classList.contains('template-cart') ) {

					/* ==========================================================
   DOÑA TOMASA - AVISO PRODUCTO AÑADIDO AL CARRITO
   Aviso centrado, sin abrir el carrito lateral.
   ========================================================== */

let cartToast = document.getElementById('dt-cart-toast');

if ( ! cartToast ) {

	cartToast = document.createElement('div');
	cartToast.id = 'dt-cart-toast';

	cartToast.setAttribute('role', 'status');
	cartToast.setAttribute('aria-live', 'polite');

	cartToast.textContent = 'Producto añadido al carrito';

	Object.assign(cartToast.style, {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: '999999',

		padding: '16px 28px',

		background: '#ffffff',
		color: '#222222',

		border: '2px solid #000000',
		borderRadius: '10px',

		boxShadow: '0 8px 24px rgba(0,0,0,.18)',

		fontSize: '16px',
		fontWeight: '600',
		lineHeight: '1.3',
		textAlign: 'center',

		minWidth: '300px',
		maxWidth: '90vw',

		opacity: '0',
		visibility: 'hidden',
		pointerEvents: 'none',

		transition: 'opacity .2s ease'
	});

	document.body.appendChild(cartToast);
}

clearTimeout(window.dtCartToastTimer);

cartToast.style.visibility = 'visible';
cartToast.style.opacity = '1';

window.dtCartToastTimer = setTimeout(() => {

	cartToast.style.opacity = '0';

	setTimeout(() => {
		cartToast.style.visibility = 'hidden';
	}, 200);

}, 1000);

/* FIN - DOÑA TOMASA - AVISO PRODUCTO AÑADIDO AL CARRITO */

					if ( document.getElementById('cart-recommendations') ) {
						document
							.getElementById('cart-recommendations')
							.generateRecommendations();
					}

					const ajaxCartForm = document.getElementById('AjaxCartForm');

					if ( ajaxCartForm ) {

						const cartTotal = ajaxCartForm.querySelector('[data-cart-total]');
						const cartCount = ajaxCartForm.querySelector('[data-cart-count]');

						if ( cartTotal ) {
							document
								.querySelectorAll('[data-header-cart-total]')
								.forEach(elm => {
									elm.textContent = cartTotal.textContent;
								});
						}

						if ( cartCount ) {
							document
								.querySelectorAll('[data-header-cart-count]')
								.forEach(elm => {
									elm.textContent = cartCount.textContent;
								});
						}

					}

				}

			});

		}

	}

	if ( typeof customElements.get('quick-add-to-cart') === 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}


if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor() {
			super();

			if ( this.querySelector('a') ) {
				this.#init();
			}
		}

		#initModalProduct() {

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm => {
				elm.addEventListener('click', () => {
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {

				this.quickViewModal
					.querySelector('[data-js-product-form]')
					.addEventListener('add-to-cart', () => {

						document
							.getElementById('site-cart-sidebar')
							?.scrollTo({
								top: 0,
								behavior: 'smooth'
							});

						this.quickViewModal.hide();

					});

			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(() => {
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('dt-product-variants');

			if ( productVariants && ! productVariants._defaultToFirstVariant ) {

				if ( parseInt(productVariants.dataset.variants) === 1 ) {

					productVariants.updateBuyButtons();

					customElements.whenDefined('product-page').then(() => {

						const productPage = this.quickViewModal.querySelector('product-page');

						if (
							productPage &&
							typeof productPage.onVariantChangeHandler === 'function'
						) {
							productPage.onVariantChangeHandler({
								target: productVariants
							});
						}

					});

				}

			}

		}

		#init() {

			this.quickViewModal = null;

			this.querySelector('a').addEventListener('keydown', e => {

				if ( e.keyCode === window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}

			});

			this.querySelector('a').addEventListener('click', e => {

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(
						`${target.getAttribute('href')}${
							target.getAttribute('href').includes('?') ? '&' : '?'
						}view=quick-view`
					)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser()
								.parseFromString(text, 'text/html')
								.querySelector('#product-quick-view');

							if ( ! quickViewHTML ) {
								target.classList.remove('working');
								return;
							}

							const quickViewContainer = document.createElement('div');

							quickViewContainer.innerHTML = `
								<modal-box
									id="modal-${target.dataset.id}"
									class="modal modal--product"
									data-options='{
										"enabled": false,
										"showOnce": false,
										"blockTabNavigation": true
									}'
									tabindex="-1"
									role="dialog"
									aria-modal="true"
								>
									<div class="container--medium">
										<div class="modal-content" data-js-product-page>
											<button
												class="modal-close"
												data-js-close
												style="position:absolute;margin:0;top:0;right:0"
											>
												${window.KROWN.settings.symbols.close}
											</button>
										</div>
									</div>

									<span class="modal-background" data-js-close></span>
								</modal-box>
							`;

							this.quickViewModal =
								quickViewContainer.querySelector('modal-box');

							document.body.appendChild(this.quickViewModal);

							this.quickViewModal
								.querySelector('.modal-content')
								.innerHTML = quickViewHTML.innerHTML;

							setTimeout(() => {
								this.#initModalProduct();
							}, 100);

							this.quickViewModal
								.querySelector('[data-js-product-page]')
								.addEventListener('reload', () => {
									this.#initModalProduct();
								});

							if ( ! window.productPageScripts ) {

								const scripts =
									this.quickViewModal.querySelectorAll('script');

								scripts.forEach(elm => {

									if ( ! elm.src ) return;

									const script = document.createElement('script');

									script.src = elm.src;
									document.body.appendChild(script);

								});

								window.productPageScripts = true;

							}

							setTimeout(() => {

								this.quickViewModal.show();
								target.classList.remove('working');

							}, 250);

						})
						.catch(error => {

							console.error('Error cargando la vista rápida:', error);
							target.classList.remove('working');

						});

				} else {

					this.quickViewModal.show();

				}

			});

		}

	}

	if ( typeof customElements.get('quick-view-product') === 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}